<template>
  <a-modal
    wrapClassName="customModal"
    v-model="showModal"
    :title="title"
    @ok="saveClassRoom"
    :width="width"
    cancelText="取消"
    okText="确定"
    :confirmLoading="submitLoading"
    :afterClose="afterClose"
    :destroyOnClose="true"
  >
    <div class="classmodal_content" @click.prevent="modalClick">
      <delete-dialog
        :showModal.sync="deleteModalShow"
        tipMsg="听课教室删除后无法恢复，请谨慎操作"
        @delete="confirmDelete"
      />
      <!-- 无导播课堂 -->
      <a-row :flex="2">
        <a-col :span="12" :offset="2">
          <div class="content_btntab">
            <a-button
              class="ZHIHUISHU_QZMD"
              :type="roomType == ROOM_TYPE_ENUM.SIMPLE ? 'primary' : 'default'"
              size="large"
              @click="changeTab(ROOM_TYPE_ENUM.SIMPLE)"
            >
              无导播课堂
            </a-button>
            <a-button
              class="ZHIHUISHU_QZMD"
              :type="roomType == ROOM_TYPE_ENUM.WISDOM ? 'primary' : 'default'"
              size="large"
              @click="changeTab(ROOM_TYPE_ENUM.WISDOM)"
              v-show="showWisdomTab"
            >
              智慧教室（主讲）
            </a-button>
            <a-button
              :type="
                roomType == ROOM_TYPE_ENUM.SMALLEST ? 'primary' : 'default'
              "
              size="large"
              @click="changeTab(ROOM_TYPE_ENUM.SMALLEST)"
              v-show="showWisdomTab"
            >
              极简教室（主讲）
            </a-button>
          </div>
        </a-col>
        <a-col :span="18" :offset="2" class="simple_box">
          <a-form
            :form="simpleForm"
            :colon="false"
            ref="simpleForm"
            v-show="roomType == ROOM_TYPE_ENUM.SIMPLE"
          >
            <div style="display: flex">
              <a-form-item label="课程名称" style="width: 47.5%">
                <a-input
                  placeholder="请输入课程名称（限50字）"
                  autocomplete="off"
                  v-decorator="[
                    'courseName',
                    {
                      rules: [
                        { required: true, message: '请输入课程名称（限50字）' },
                        { max: 50, message: '课程名称不得大于50字' },
                      ],
                    },
                  ]"
                  :maxLength="50"
                  allowClear
                />
              </a-form-item>
              <a-form-item label="学期" style="width: 47.5%; margin-left: 5%">
                <a-select
                  v-decorator="[
                    'term',
                    {
                      rules: [{ required: true, message: '请选择学期' }],
                    },
                  ]"
                  placeholder="请选择学期"
                >
                  <a-select-option
                    :value="item.value"
                    v-for="item in termInfo"
                    :key="item.value"
                  >
                    {{ item.name }}
                  </a-select-option>
                </a-select>
              </a-form-item>
            </div>
            <h3>授课时间</h3>
            <div
              style="display: flex; position: relative"
              v-for="(item, index) in teachAddArrSim"
              :key="item.index"
              @click.stop.prevent
            >
              <a-form-item label="开始时间">
                <a-time-picker
                  placeholder="开始时间"
                  v-decorator="[
                    `startTime${index}`,
                    {
                      rules: [{ required: true, message: '请选择时间' }],
                    },
                  ]"
                  format="HH:mm"
                  :getPopupContainer="(triggerNode) => triggerNode.parentNode"
                />
              </a-form-item>
              <a-form-item label="结束时间" style="margin-left: 30px">
                <a-time-picker
                  placeholder="结束时间"
                  v-decorator="[
                    `endTime${index}`,
                    {
                      rules: [{ required: true, message: '请选择时间' }],
                    },
                  ]"
                  format="HH:mm"
                  :getPopupContainer="(triggerNode) => triggerNode.parentNode"
                />
              </a-form-item>
              <a-form-item label="授课日期" style="margin-left: 30px">
                <a-date-picker
                  placeholder="请选择日期"
                  v-decorator="[
                    `courseTime${index}`,
                    {
                      rules: [{ required: true, message: '请选择日期' }],
                    },
                  ]"
                  style="width: 285px"
                  inputReadOnly
                  @change="
                    (value, dateString) =>
                      handleCourseTimeChange(value, dateString, index)
                  "
                  :open="item.showDate"
                  :showToday="false"
                  dropdownClassName="course_time_picker"
                  :getCalendarContainer="
                    (triggerNode) => triggerNode.parentNode
                  "
                >
                  <template slot="dateRender" slot-scope="current, today">
                    <div
                      class="ant-calendar-date"
                      :style="getCurrentStyle(current, today, index)"
                    >
                      {{ current.date() }}
                    </div>
                  </template>
                  <template slot="renderExtraFooter">
                    <div
                      style="
                        display: flex;
                        justify-content: flex-end;
                        padding: 5px 0;
                      "
                    >
                      <a-button
                        type="danger"
                        size="small"
                        style="margin-right: 15px"
                        @click.stop.prevent="cleanDateArr(index)"
                      >
                        重置
                      </a-button>
                      <a-button
                        type="primary"
                        size="small"
                        @click.stop.prevent="
                          handleShowDatePickerChange(false, index)
                        "
                      >
                        确定
                      </a-button>
                    </div>
                  </template>
                  <div
                    :class="[
                      item.showDate ? 'course_date_active' : '',
                      'course_date',
                      'ZHIHUISHU_QZMD',
                    ]"
                    @click="handleShowDatePickerChange(true, index)"
                  >
                    <div class="tag_list">
                      <div
                        class="course_date_tag"
                        v-for="dateTime in item.dateArr"
                        :key="dateTime.index"
                      >
                        {{ moment(dateTime).format('YYYY-MM-DD') }}
                      </div>
                      <div
                        v-show="item.dateArr.length == 0"
                        class="placeholder"
                      >
                        请选择授课日期
                      </div>
                    </div>
                    <div v-show="item.dateArr.length > 3" class="ellipsis">
                      ...
                    </div>
                    <a-icon slot="suffix" type="calendar" />
                  </div>
                </a-date-picker>
              </a-form-item>
              <a-button
                type="primary"
                shape="circle"
                @click="addTeachDate"
                class="shouke_btn_add ZHIHUISHU_QZMD"
                v-if="index == 0"
              >
                +
              </a-button>
              <a-button
                type="danger"
                shape="circle"
                @click="delTeachDate(index)"
                class="shouke_btn_del ZHIHUISHU_QZMD"
                v-if="index != 0"
              >
                -
              </a-button>
            </div>
            <div style="display: flex; margin-top: 15px">
              <a-form-item label="主讲学校（非必选）" style="width: 47.5%">
                <a-select
                  v-decorator="['schoolId']"
                  placeholder="请选择主讲学校"
                  @change="handleSchoolChange"
                  :getPopupContainer="(triggerNode) => triggerNode.parentNode"
                  showSearch
                  optionFilterProp="children"
                >
                  <a-select-option
                    :key="item.id"
                    :value="item.id"
                    v-for="item in schoolListSim"
                  >
                    {{ item.schoolName }}
                  </a-select-option>
                </a-select>
              </a-form-item>
              <a-form-item
                label="主讲教室（非必选）"
                style="width: 47.5%; margin-left: 5%"
              >
                <a-select
                  v-decorator="['classRoomId']"
                  placeholder="请选择主讲教室"
                  @change="handleClassRoomChange"
                  showSearch
                  optionFilterProp="children"
                >
                  <a-select-option
                    :value="item.classroomCode"
                    v-for="item in classRoomListSim"
                    :key="item.classroomCode"
                  >
                    {{ item.classroomName }}
                  </a-select-option>
                </a-select>
              </a-form-item>
            </div>
            <a-form-item label="主讲老师（非必选）" style="width: 47.5%">
              <a-select
                v-decorator="['teacherId']"
                placeholder="请选择主讲老师"
                showSearch
                optionFilterProp="children"
              >
                <a-select-option
                  :value="item.zhsId"
                  v-for="item in teacherListSim"
                  :key="item.zhsId"
                >
                  {{ item.realName }}
                </a-select-option>
              </a-select>
            </a-form-item>
          </a-form>
        </a-col>
        <!-- wisdom 智慧教室 -->
        <a-col :span="24" :offset="0" class="scroll-box" ref="scrollBox">
          <a-col :span="18" :offset="2">
            <a-form
              :form="wisdomForm"
              :colon="false"
              ref="wisdomForm"
              v-show="roomType == ROOM_TYPE_ENUM.WISDOM"
            >
              <div style="display: flex">
                <a-form-item label="课程名称" style="width: 60%">
                  <a-input
                    placeholder="请输入课程名称（限50字）"
                    autocomplete="off"
                    v-decorator="[
                      'liveName',
                      {
                        rules: [
                          {
                            required: true,
                            message: '请输入课程名称（限50字）',
                          },
                          { max: 50, message: '课程名称不得大于50字' },
                        ],
                      },
                    ]"
                    :maxLength="50"
                    allowClear
                  />
                </a-form-item>
                <a-form-item label="学期" style="width: 35%; margin-left: 5%">
                  <a-select
                    v-decorator="[
                      'term',
                      {
                        rules: [{ required: true, message: '请选择学期' }],
                      },
                    ]"
                    placeholder="请选择学期"
                    :getPopupContainer="(triggerNode) => triggerNode.parentNode"
                  >
                    <a-select-option
                      :value="item.value"
                      v-for="item in termInfo"
                      :key="item.value"
                    >
                      {{ item.name }}
                    </a-select-option>
                  </a-select>
                </a-form-item>
              </div>
              <a-form-item label="主讲人">
                <a-input
                  placeholder="请填写主讲人"
                  autocomplete="off"
                  allowClear
                  v-decorator="[
                    'teacherName',
                    {
                      rules: [{ required: true, message: '请填写主讲人' }],
                    },
                  ]"
                />
              </a-form-item>
              <a-form-item label="课程专员">
                <a-select
                  v-decorator="[
                    'commissionerId',
                    {
                      rules: [{ required: true, message: '请选择课程专员' }],
                    },
                  ]"
                  placeholder="请选择课程专员"
                  showSearch
                  optionFilterProp="children"
                >
                  <a-select-option
                    v-for="item in commissionerList"
                    :value="item.id"
                    :key="item.id"
                    
                  >
                    {{ item.name }}
                  </a-select-option>
                </a-select>
              </a-form-item>
              <h3>授课时间</h3>
              <div
                style="display: flex; position: relative"
                v-for="(item, index) in teachAddArrWis"
                :key="item.index"
                @click.stop.prevent
              >
                <a-form-item label="开始时间">
                  <a-time-picker
                    placeholder="开始时间"
                    v-decorator="[
                      `startTime${index}`,
                      {
                        rules: [{ required: true, message: '请选择时间' }],
                      },
                    ]"
                    format="HH:mm"
                    :getPopupContainer="(triggerNode) => triggerNode.parentNode"
                  />
                </a-form-item>
                <a-form-item label="结束时间" style="margin-left: 30px">
                  <a-time-picker
                    placeholder="结束时间"
                    v-decorator="[
                      `endTime${index}`,
                      {
                        rules: [{ required: true, message: '请选择时间' }],
                      },
                    ]"
                    format="HH:mm"
                    :getPopupContainer="(triggerNode) => triggerNode.parentNode"
                  />
                </a-form-item>
                <a-form-item label="授课日期" style="margin-left: 30px">
                  <a-date-picker
                    placeholder="请选择日期"
                    v-decorator="[
                      `courseTimeWis${index}`,
                      {
                        rules: [{ required: true, message: '请选择日期' }],
                      },
                    ]"
                    @change="
                      (value, dateString) =>
                        handleCourseTimeChange(value, dateString, index)
                    "
                    :open="item.showDate"
                    :getCalendarContainer="
                      (triggerNode) => triggerNode.parentNode
                    "
                    :showToday="false"
                    style="width: 285px"
                    dropdownClassName="course_time_picker"
                  >
                    <template slot="dateRender" slot-scope="current, today">
                      <div
                        class="ant-calendar-date"
                        :style="getCurrentStyle(current, today, index)"
                      >
                        {{ current.date() }}
                      </div>
                    </template>
                    <template slot="renderExtraFooter">
                      <div
                        style="
                          display: flex;
                          justify-content: flex-end;
                          padding: 5px 0;
                        "
                      >
                        <a-button
                          type="danger"
                          size="small"
                          style="margin-right: 15px"
                          @click.stop.prevent="cleanDateArr(index)"
                        >
                          重置
                        </a-button>
                        <a-button
                          type="primary"
                          size="small"
                          @click.stop.prevent="
                            handleShowDatePickerChange(false, index)
                          "
                          >确定</a-button
                        >
                      </div>
                    </template>
                    <div
                      :class="[
                        item.showDate ? 'course_date_active' : '',
                        'course_date',
                      ]"
                      @click="handleShowDatePickerChange(true, index)"
                    >
                      <div class="tag_list">
                        <div
                          class="course_date_tag"
                          v-for="dateTime in item.dateArr"
                          :key="dateTime.index"
                        >
                          {{ moment(dateTime).format('YYYY-MM-DD') }}
                        </div>
                        <div
                          v-show="item.dateArr.length == 0"
                          class="placeholder"
                        >
                          请选择授课日期
                        </div>
                      </div>
                      <div v-show="item.dateArr.length > 3" class="ellipsis">
                        ...
                      </div>
                      <a-icon slot="suffix" type="calendar" />
                    </div>
                  </a-date-picker>
                </a-form-item>
                <a-button
                  type="primary"
                  shape="circle"
                  @click="addTeachDate"
                  class="shouke_btn_add"
                  v-if="index == 0"
                >
                  +
                </a-button>
                <a-button
                  type="danger"
                  shape="circle"
                  @click="delTeachDate(index)"
                  class="shouke_btn_del"
                  v-if="index != 0"
                >
                  -
                </a-button>
              </div>
              <h3>主讲教室配置</h3>
              <a-form-item label="主讲学校">
                <a-select
                  v-decorator="[
                    'schoolId',
                    {
                      rules: [{ required: true, message: '请选择主讲学校' }],
                    },
                  ]"
                  placeholder="请选择主讲学校"
                  @change="handleSchoolChange"
                  :getPopupContainer="(triggerNode) => triggerNode.parentNode"
                  showSearch
                  optionFilterProp="children"
                >
                  <a-select-option
                    v-for="item in schoolListWis"
                    :key="item.id"
                    :value="item.id"
                  >
                    {{ item.schoolName }}
                  </a-select-option>
                </a-select>
              </a-form-item>
              <a-form-item label="主讲教室">
                <a-select
                  v-decorator="[
                    'classRoomId',
                    {
                      rules: [{ required: true, message: '请选择主讲教室' }],
                    },
                  ]"
                  placeholder="请选择主讲教室"
                  @change="handleClassRoomChange"
                  showSearch
                  optionFilterProp="children"
                  :getPopupContainer="(triggerNode) => triggerNode.parentNode"
                >
                  <a-select-option
                    :value="item.classroomCode"
                    v-for="item in classRoomListWis"
                    :key="item.classroomCode"
                  >
                    {{ item.classroomName }}
                  </a-select-option>
                </a-select>
              </a-form-item>
              <a-form-item label="主讲导播">
                <a-select
                  v-decorator="['teacherId']"
                  placeholder="请选择主讲导播"
                  showSearch
                  optionFilterProp="children"
                  :getPopupContainer="(triggerNode) => triggerNode.parentNode"
                >
                  <a-select-option
                    :value="item.zhsId"
                    v-for="item in teacherListWis"
                    :key="item.zhsId"
                  >
                    {{ item.realName }}
                  </a-select-option>
                </a-select>
              </a-form-item>
              <h3>听课教室配置</h3>
              <a-form-item label="听课学校">
                <a-select
                  v-decorator="['listenSchool']"
                  placeholder="请选择听课学校"
                  @change="handleListenSchoolChange"
                  showSearch
                  optionFilterProp="children"
                  :getPopupContainer="(triggerNode) => triggerNode.parentNode"
                >
                  <a-select-option
                    v-for="item in schoolListWis"
                    :key="item.id"
                    :value="item.id"
                  >
                    {{ item.schoolName }}
                  </a-select-option>
                </a-select>
              </a-form-item>
              <a-form-item label="听课教室">
                <a-select
                  v-decorator="['listenClassroom']"
                  placeholder="请选择听课教室"
                  @change="handleListenClassRoomChange"
                  showSearch
                  optionFilterProp="children"
                  :getPopupContainer="(triggerNode) => triggerNode.parentNode"
                >
                  <a-select-option
                    v-for="item in listenClassRoomList"
                    :value="item.classroomCode"
                    :key="item.classroomCode"
                  >
                    {{ item.classroomName }}
                  </a-select-option>
                </a-select>
              </a-form-item>
              <a-form-item
                label="听课导播"
                style="position: relative; width: 50%"
              >
                <a-select
                  v-decorator="['listenDaobo']"
                  placeholder="请选择听课导播"
                  showSearch
                  optionFilterProp="children"
                  :getPopupContainer="(triggerNode) => triggerNode.parentNode"
                >
                  <a-select-option
                    :value="item.zhsId"
                    v-for="item in teacherListListenWis"
                    :key="item.zhsId"
                  >
                    {{ item.realName }}
                  </a-select-option>
                </a-select>
                <a-button
                  type="primary"
                  class="add_class_room_btn"
                  @click="handleAddListenClassRoomClick"
                >
                  添加一间教室
                </a-button>
              </a-form-item>
              <a-table
                :columns="columns"
                :data-source="listenDataWis"
                :pagination="false"
                bordered
                :scroll="{ x: 780 }"
                style="width: 100%"
                class="content_table"
              >
                <template slot="schoolName" slot-scope="text">
                  <a>{{ text }}</a>
                </template>
                <span slot="action" slot-scope="text, record">
                  <a-button type="danger" @click="deleteListenOneData(text)">
                    删除
                  </a-button>
                </span>
              </a-table>
              <h3>互动策略（导播可见）</h3>
              <a-form-item style="margin-top: 10px">
                <a-textarea
                  placeholder="请输入互动策略"
                  v-decorator="['tactics']"
                  :rows="4"
                />
              </a-form-item>
            </a-form>
          </a-col>
        </a-col>
        <!-- smallest 极简教室 纯极简当主讲 -->
        <a-col :span="24" :offset="0" class="scroll-box" ref="scrollBox">
          <a-col :span="18" :offset="2">
            <a-form
              :form="smallestForm"
              :colon="false"
              ref="smallestForm"
              v-show="roomType == ROOM_TYPE_ENUM.SMALLEST"
            >
              <div style="display: flex">
                <a-form-item label="课程名称" style="width: 60%">
                  <a-input
                    placeholder="请输入课程名称（限50字）"
                    autocomplete="off"
                    v-decorator="[
                      'liveName',
                      {
                        rules: [
                          {
                            required: true,
                            message: '请输入课程名称（限50字）',
                          },
                          { max: 50, message: '课程名称不得大于50字' },
                        ],
                      },
                    ]"
                    :maxLength="50"
                    allowClear
                  />
                </a-form-item>
                <a-form-item label="学期" style="width: 35%; margin-left: 5%">
                  <a-select
                    v-decorator="[
                      'term',
                      {
                        rules: [{ required: true, message: '请选择学期' }],
                      },
                    ]"
                    placeholder="请选择学期"
                    :getPopupContainer="(triggerNode) => triggerNode.parentNode"
                  >
                    <a-select-option
                      :value="item.value"
                      v-for="item in termInfo"
                      :key="item.value"
                    >
                      {{ item.name }}
                    </a-select-option>
                  </a-select>
                </a-form-item>
              </div>
              <a-form-item label="主讲人">
                <a-input
                  placeholder="请填写主讲人"
                  autocomplete="off"
                  allowClear
                  v-decorator="[
                    'teacherName',
                    {
                      rules: [{ required: true, message: '请填写主讲人' }],
                    },
                  ]"
                />
              </a-form-item>
              <a-form-item label="课程专员">
                <a-select
                  v-decorator="[
                    'commissionerId',
                    {
                      rules: [{ required: true, message: '请选择课程专员' }],
                    },
                  ]"
                  placeholder="请选择课程专员"
                  showSearch
                  optionFilterProp="children"
                >
                  <a-select-option
                    v-for="item in commissionerList"
                    :value="item.id"
                    :key="item.id"
                    
                  >
                    {{ item.name }}
                  </a-select-option>
                </a-select>
              </a-form-item>
              <h3>授课时间</h3>
              <div
                style="display: flex; position: relative"
                v-for="(item, index) in teachAddArrSma"
                :key="item.index"
                @click.stop.prevent
              >
                <a-form-item label="开始时间">
                  <a-time-picker
                    placeholder="开始时间"
                    v-decorator="[
                      `startTime${index}`,
                      {
                        rules: [{ required: true, message: '请选择时间' }],
                      },
                    ]"
                    format="HH:mm"
                    :getPopupContainer="(triggerNode) => triggerNode.parentNode"
                  />
                </a-form-item>
                <a-form-item label="结束时间" style="margin-left: 30px">
                  <a-time-picker
                    placeholder="结束时间"
                    v-decorator="[
                      `endTime${index}`,
                      {
                        rules: [{ required: true, message: '请选择时间' }],
                      },
                    ]"
                    format="HH:mm"
                    :getPopupContainer="(triggerNode) => triggerNode.parentNode"
                  />
                </a-form-item>
                <a-form-item label="授课日期" style="margin-left: 30px">
                  <a-date-picker
                    placeholder="请选择日期"
                    v-decorator="[
                      `courseTimeWis${index}`,
                      {
                        rules: [{ required: true, message: '请选择日期' }],
                      },
                    ]"
                    @change="
                      (value, dateString) =>
                        handleCourseTimeChange(value, dateString, index)
                    "
                    :open="item.showDate"
                    :getCalendarContainer="
                      (triggerNode) => triggerNode.parentNode
                    "
                    :showToday="false"
                    style="width: 285px"
                    dropdownClassName="course_time_picker"
                  >
                    <template slot="dateRender" slot-scope="current, today">
                      <div
                        class="ant-calendar-date"
                        :style="getCurrentStyle(current, today, index)"
                      >
                        {{ current.date() }}
                      </div>
                    </template>
                    <template slot="renderExtraFooter">
                      <div
                        style="
                          display: flex;
                          justify-content: flex-end;
                          padding: 5px 0;
                        "
                      >
                        <a-button
                          type="danger"
                          size="small"
                          style="margin-right: 15px"
                          @click.stop.prevent="cleanDateArr(index)"
                        >
                          重置
                        </a-button>
                        <a-button
                          type="primary"
                          size="small"
                          @click.stop.prevent="
                            handleShowDatePickerChange(false, index)
                          "
                          >确定</a-button
                        >
                      </div>
                    </template>
                    <div
                      :class="[
                        item.showDate ? 'course_date_active' : '',
                        'course_date',
                        'ZHIHUISHU_QZMD',
                      ]"
                      @click="handleShowDatePickerChange(true, index)"
                    >
                      <div class="tag_list">
                        <div
                          class="course_date_tag"
                          v-for="dateTime in item.dateArr"
                          :key="dateTime.index"
                        >
                          {{ moment(dateTime).format('YYYY-MM-DD') }}
                        </div>
                        <div
                          v-show="item.dateArr.length == 0"
                          class="placeholder"
                        >
                          请选择授课日期
                        </div>
                      </div>
                      <div v-show="item.dateArr.length > 3" class="ellipsis">
                        ...
                      </div>
                      <a-icon slot="suffix" type="calendar" />
                    </div>
                  </a-date-picker>
                </a-form-item>
                <a-button
                  type="primary"
                  shape="circle"
                  @click="addTeachDate"
                  class="shouke_btn_add ZHIHUISHU_QZMD"
                  v-if="index == 0"
                >
                  +
                </a-button>
                <a-button
                  type="danger"
                  shape="circle"
                  @click="delTeachDate(index)"
                  class="shouke_btn_del ZHIHUISHU_QZMD"
                  v-if="index != 0"
                >
                  -
                </a-button>
              </div>
              <h3>主讲教室配置</h3>
              <a-form-item label="主讲学校">
                <a-select
                  v-decorator="[
                    'schoolId',
                    {
                      rules: [{ required: true, message: '请选择主讲学校' }],
                    },
                  ]"
                  placeholder="请选择主讲学校"
                  @change="handleSchoolChange"
                  :getPopupContainer="(triggerNode) => triggerNode.parentNode"
                  showSearch
                  optionFilterProp="children"
                >
                  <a-select-option
                    v-for="item in schoolListWis"
                    :key="item.id"
                    :value="item.id"
                  >
                    {{ item.schoolName }}
                  </a-select-option>
                </a-select>
              </a-form-item>
              <a-form-item label="主讲教室">
                <a-select
                  v-decorator="[
                    'classRoomId',
                    {
                      rules: [{ required: true, message: '请选择主讲教室' }],
                    },
                  ]"
                  placeholder="请选择主讲教室"
                  @change="handleClassRoomChange"
                  showSearch
                  optionFilterProp="children"
                  :getPopupContainer="(triggerNode) => triggerNode.parentNode"
                >
                  <a-select-option
                    :value="item.classroomCode"
                    v-for="item in classRoomListSma"
                    :key="item.classroomCode"
                  >
                    {{ item.classroomName }}
                  </a-select-option>
                </a-select>
              </a-form-item>
              <a-form-item label="主讲导播">
                <a-select
                  v-decorator="['teacherId']"
                  placeholder="请选择主讲导播"
                  showSearch
                  optionFilterProp="children"
                  :getPopupContainer="(triggerNode) => triggerNode.parentNode"
                >
                  <a-select-option
                    :value="item.zhsId"
                    v-for="item in teacherListSma"
                    :key="item.zhsId"
                  >
                    {{ item.realName }}
                  </a-select-option>
                </a-select>
              </a-form-item>
              <h3>听课教室配置</h3>
              <a-form-item label="听课学校">
                <a-select
                  v-decorator="['listenSchool']"
                  placeholder="请选择听课学校"
                  @change="handleListenSchoolChange"
                  showSearch
                  optionFilterProp="children"
                  :getPopupContainer="(triggerNode) => triggerNode.parentNode"
                >
                  <a-select-option
                    v-for="item in schoolListWis"
                    :key="item.id"
                    :value="item.id"
                  >
                    {{ item.schoolName }}
                  </a-select-option>
                </a-select>
              </a-form-item>
              <a-form-item label="听课教室">
                <a-select
                  v-decorator="['listenClassroom']"
                  placeholder="请选择听课教室"
                  @change="handleListenClassRoomChange"
                  showSearch
                  optionFilterProp="children"
                  :getPopupContainer="(triggerNode) => triggerNode.parentNode"
                >
                  <a-select-option
                    v-for="item in listenClassRoomList"
                    :value="item.classroomCode"
                    :key="item.classroomCode"
                  >
                    {{ item.classroomName }}
                  </a-select-option>
                </a-select>
              </a-form-item>
              <a-form-item
                label="听课导播"
                style="position: relative; width: 50%"
              >
                <a-select
                  v-decorator="['listenDaobo']"
                  placeholder="请选择听课导播"
                  showSearch
                  optionFilterProp="children"
                  :getPopupContainer="(triggerNode) => triggerNode.parentNode"
                >
                  <a-select-option
                    :value="item.zhsId"
                    v-for="item in teacherListListenSma"
                    :key="item.zhsId"
                  >
                    {{ item.realName }}
                  </a-select-option>
                </a-select>
                <a-button
                  type="primary"
                  class="add_class_room_btn ZHIHUISHU_QZMD"
                  @click="handleAddListenClassRoomClick"
                >
                  添加一间教室
                </a-button>
              </a-form-item>
              <a-table
                :columns="columns"
                :data-source="listenDataSma"
                :pagination="false"
                bordered
                :scroll="{ x: 780 }"
                style="width: 100%"
                class="content_table"
              >
                <template slot="schoolName" slot-scope="text">
                  <a>{{ text }}</a>
                </template>
                <span slot="action" slot-scope="text, record">
                  <a-button
                    class="ZHIHUISHU_QZMD"
                    type="danger"
                    @click="deleteListenOneData(text)"
                  >
                    删除
                  </a-button>
                </span>
              </a-table>
              <h3>互动策略（导播可见）</h3>
              <a-form-item style="margin-top: 10px">
                <a-textarea
                  placeholder="请输入互动策略"
                  v-decorator="['tactics']"
                  :rows="4"
                />
              </a-form-item>
            </a-form>
          </a-col>
        </a-col>
      </a-row>
    </div>
    <loading-create-dialog
      :showModalProp.sync="showLoadingCreateDialog"
      :courseId="loadingCourseId"
    />
  </a-modal>
</template>

<script>
import moment from 'moment'
import { mapGetters } from 'vuex'
import { ROOM_TYPE_ENUM } from './const'

const columns = [
  {
    title: '学校名称',
    dataIndex: 'schoolName',
    scopedSlots: { customRender: 'schoolName' },
  },
  {
    title: '教室名称',
    dataIndex: 'className',
  },
  {
    title: '教室类型',
    dataIndex: 'roomType',
  },
  {
    title: '导播名称',
    dataIndex: 'realName',
  },
  {
    title: '手机号码',
    dataIndex: 'mobile',
  },
  {
    title: '操作',
    fixed: 'right',
    key: 'action',
    scopedSlots: { customRender: 'action' },
  },
]

export default {
  props: {
    type: {
      type: String,
      default: () => {
        return 'liveStreaming'
      },
    },
    title: {
      type: String,
      default: () => '创建课程(周期)',
    },
    width: {
      type: Number,
      default: () => 850,
    },
    showModalProp: {
      type: Boolean,
      default: () => false,
    },
  },
  components: {
    'delete-dialog': () => import('../../components/deleteDialog'),
    'loading-create-dialog': () =>
      import('../../components/loadingCreateDialog'),
  },
  data() {
    return {
      showModal: false,
      submitLoading: false,
      roomType: 'simple', // simple wisdom
      formLayout: 'horizontal',
      simpleForm: this.$form.createForm(this, { name: 'simpleForm' }),
      wisdomForm: this.$form.createForm(this, { name: 'wisdomForm' }),
      smallestForm: this.$form.createForm(this, { name: 'smallestForm' }),
      courseTimeWis: undefined,
      listenDataWis: [],
      listenDataSma: [],
      columns,
      termInfo: [],
      teachAddArrSim: [
        {
          index: 0,
          dateArr: [],
          showDate: false,
        },
      ],
      teachAddArrWis: [
        {
          index: 0,
          courseTimeStr: '',
          dateArr: [],
          showDate: false,
        },
      ],
      teachAddArrSma: [
        {
          index: 0,
          courseTimeStr: '',
          dateArr: [],
          showDate: false,
        },
      ],
      ROOM_TYPE_ENUM,
      schoolListSim: [], // 无导播课堂主讲学校列表
      schoolListWis: [], // 智慧课堂主讲学校列表
      classRoomListSim: [], // 无导播课堂主讲教室列表
      classRoomListWis: [], // 智慧课堂主讲教室列表
      classRoomListSma: [], // 极简课堂主讲教室列表
      teacherListSim: [], // 无导播课堂导播列表
      teacherListWis: [], // 智慧课堂导播列表
      teacherListSma: [], // 极简课堂导播列表
      teacherListListenWis: [], // 智慧听课导师列表
      teacherListListenSma: [], // 极简听课导师列表
      listenClassRoomList: [], // 听课教室列表
      deleteModalShow: false, // 删除弹框
      deleteData: {},
      showLoadingCreateDialog: false, // 是否显示创建课程后的loading
      loadingCourseId: '', // loading页的课程id
      commissionerList: [] // 所有专员列表 
    }
  },
  watch: {
    showModalProp(newVal, oldVal) {
      this.showModal = newVal
      if (newVal) {
        this.setSchoolClassRoomTeacher()
      }
    },
  },
  created() {
    this.init()
    this.$bus.$on('createCourseOk', () => {
      this.$emit('refresh')
      this.submitLoading = false
      this.showModal = false
    })
  },
  beforeDestroy() {
    this.$bus.$off('createCourseOk')
  },
  destroyed() {
    let scrollBox = this.$refs.scrollBox?.$el
    if (scrollBox)
      scrollBox.removeEventListener('scroll', this.handScrollChange)
  },
  computed: {
    ...mapGetters('userInfo', ['userInfo']),
    showWisdomTab() {
      // 0 普通用户 1 管理员用户
      return this.userInfo.userType == 1
    },
  },
  methods: {
    handScrollChange() {
      // 监听滚动关闭日期弹框
      let wisdomDateInput = this.$refs.wisdomDateInput
      if (wisdomDateInput) {
        wisdomDateInput[0].blur()
      }
      this.handleShowDatePickerChange(false, 'all')
    },
    modalClick() {
      this.handleShowDatePickerChange(false, 'all')
    },
    handleShowDatePickerChange(status, index) {
      if (this.roomType == ROOM_TYPE_ENUM.SIMPLE) {
        this.teachAddArrSim = this.teachAddArrSim.map((item) => {
          return { ...item, ...{ showDate: false } }
        })
      } else if (this.roomType == ROOM_TYPE_ENUM.WISDOM) {
        this.teachAddArrWis = this.teachAddArrWis.map((item) => {
          return { ...item, ...{ showDate: false } }
        })
      } else if (this.roomType == ROOM_TYPE_ENUM.SMALLEST) {
        this.teachAddArrSma = this.teachAddArrSma.map((item) => {
          return { ...item, ...{ showDate: false } }
        })
      }
      if (index == 'all') {
        this.teachAddArrSim = this.teachAddArrSim.map((item) => {
          return {
            ...item,
            showDate: false,
          }
        })
        this.teachAddArrWis = this.teachAddArrWis.map((item) => {
          return {
            ...item,
            showDate: false,
          }
        })
        this.teachAddArrSma = this.teachAddArrSma.map((item) => {
          return {
            ...item,
            showDate: false,
          }
        })
        return
      }
      if (this.roomType == ROOM_TYPE_ENUM.SIMPLE) {
        this.teachAddArrSim[index].showDate = status
      } else if (this.roomType == ROOM_TYPE_ENUM.WISDOM) {
        this.teachAddArrWis[index].showDate = status
      } else if (this.roomType == ROOM_TYPE_ENUM.SMALLEST) {
        this.teachAddArrSma[index].showDate = status
      }
    },
    changeTab(type) {
      this.roomType = type
      if (type == ROOM_TYPE_ENUM.WISDOM) {
        let scrollBox = this.$refs.scrollBox.$el
        if (scrollBox) {
          scrollBox.removeEventListener('scroll', this.handScrollChange)
          scrollBox.addEventListener('scroll', this.handScrollChange)
        }
      }
      if (
        this.simpleForm.getFieldValue('schoolId') == undefined ||
        this.wisdomForm.getFieldValue('schoolId') == undefined ||
        this.smallestForm.getFieldValue('schoolId') == undefined
      ) {
        this.setSchoolClassRoomTeacher()
      }
    },
    /**
     * @description: 初始化表单学校和学期
     * @param {*}
     * @return {*}
     */
    setSchoolClassRoomTeacher() {
      this.$nextTick(async () => {
        if (this.roomType == ROOM_TYPE_ENUM.SIMPLE) {
          this.simpleForm.setFieldsValue({
            schoolId: this.schoolListSim[0]?.id,
            term: this.termInfo[0]?.value || '',
          })
          await this.handleSchoolChange(this.schoolListSim[0]?.id)
          await this.handleClassRoomChange(
            this.classRoomListSim[0]?.classRoomId
          )
        } else if (this.roomType == ROOM_TYPE_ENUM.WISDOM) {
          this.wisdomForm.setFieldsValue({
            schoolId: this.schoolListWis[0]?.id,
            term: this.termInfo[0]?.value || '',
          })
          await this.handleSchoolChange(this.schoolListWis[0]?.id)
          await this.handleClassRoomChange(
            this.classRoomListWis[0]?.classroomCode
          )
        } else if (this.roomType == ROOM_TYPE_ENUM.SMALLEST) {
          this.smallestForm.setFieldsValue({
            schoolId: this.schoolListWis[0]?.id,
            term: this.termInfo[0]?.value || '',
          })
          await this.handleSchoolChange(this.schoolListWis[0]?.id)
          await this.handleClassRoomChange(
            this.classRoomListWis[0]?.classroomCode
          )
        }
      })
    },
    getCurrentStyle(current, today, index) {
      const style = {}
      let dateArr = []
      if (this.roomType == ROOM_TYPE_ENUM.SIMPLE) {
        dateArr = this.teachAddArrSim[index].dateArr || []
      } else if (this.roomType == ROOM_TYPE_ENUM.WISDOM) {
        dateArr = this.teachAddArrWis[index].dateArr || []
      } else if (this.roomType == ROOM_TYPE_ENUM.SMALLEST) {
        dateArr = this.teachAddArrSma[index].dateArr || []
      }
      let dateArrDateArr = dateArr.map((item) => moment(item).format('MM-DD'))
      if (dateArrDateArr.includes(moment(current).format('MM-DD'))) {
        style.border = '1px solid transparent'
        style.color = '#fff'
        style.borderRadius = '2px'
        style.backgroundColor = '#1890ff'
      }
      return style
    },
    // 删除一条授课规律
    delTeachDate(index) {
      if (this.roomType == ROOM_TYPE_ENUM.SIMPLE) {
        this.teachAddArrSim.splice(index, 1)
      } else if (this.roomType == ROOM_TYPE_ENUM.WISDOM) {
        this.teachAddArrWis.splice(index, 1)
      } else if (this.roomType == ROOM_TYPE_ENUM.SMALLEST) {
        this.teachAddArrSma.splice(index, 1)
      }
    },
    // 添加一条授课规律
    addTeachDate() {
      if (this.roomType == ROOM_TYPE_ENUM.SIMPLE) {
        this.teachAddArrSim.push({
          index: this.teachAddArrSim.length + 1,
          dateArr: [],
          showDate: false,
        })
      } else if (this.roomType == ROOM_TYPE_ENUM.WISDOM) {
        this.teachAddArrWis.push({
          index: this.teachAddArrWis.length + 1,
          dateArr: [],
          showDate: false,
        })
      } else if (this.roomType == ROOM_TYPE_ENUM.SMALLEST) {
        this.teachAddArrSma.push({
          index: this.teachAddArrSma.length + 1,
          dateArr: [],
          showDate: false,
        })
      }
    },
    // 清除所有授课日期
    cleanDateArr(index) {
      if (this.roomType == ROOM_TYPE_ENUM.SIMPLE) {
        this.teachAddArrSim[index].dateArr = []
      } else if (this.roomType == ROOM_TYPE_ENUM.WISDOM) {
        this.teachAddArrWis[index].dateArr = []
      } else if (this.roomType == ROOM_TYPE_ENUM.SMALLEST) {
        this.teachAddArrSma[index].dateArr = []
      }
    },
    // 删除一条授课日期
    deleteOneDate(index) {
      if (this.roomType == ROOM_TYPE_ENUM.SIMPLE) {
        let dataArr = this.teachAddArrSim[index].dateArr || []
        if (dataArr.length) {
          dataArr.pop()
          this.teachAddArrSim[index].dateArr = dataArr
        }
      } else if (this.roomType == ROOM_TYPE_ENUM.WISDOM) {
        let dataArr = this.teachAddArrWis[index].dateArr || []
        if (dataArr.length) {
          dataArr.pop()
          this.teachAddArrWis[index].dateArr = dataArr
        }
      } else if (this.roomType == ROOM_TYPE_ENUM.SMALLEST) {
        let dataArr = this.teachAddArrSma[index].dateArr || []
        if (dataArr.length) {
          dataArr.pop()
          this.teachAddArrSma[index].dateArr = dataArr
        }
      }
    },
    // 授课日期改变
    handleCourseTimeChange(value, dateString, index) {
      if (value == null) return
      if (this.roomType == ROOM_TYPE_ENUM.SIMPLE) {
        // 没有日期就添加 有就删除
        let fIndex = this.teachAddArrSim[index].dateArr?.findIndex(
          (item) => moment(item).valueOf() == moment(value).valueOf()
        )
        if (fIndex == -1) {
          this.teachAddArrSim[index].dateArr?.push(value)
          this.teachAddArrSim[index].dateArr?.sort((a, b) => {
            return moment(a).valueOf() - moment(b).valueOf()
          })
        } else {
          this.teachAddArrSim[index].dateArr?.splice(fIndex, 1)
          if (this.teachAddArrSim[index].dateArr.length == 0) {
          }
        }
      } else if (this.roomType == ROOM_TYPE_ENUM.WISDOM) {
        // 没有日期就添加 有就删除
        let fIndex = this.teachAddArrWis[index].dateArr?.findIndex(
          (item) => moment(item).valueOf() == moment(value).valueOf()
        )
        if (fIndex == -1) {
          this.teachAddArrWis[index].dateArr?.push(value)
          this.teachAddArrWis[index].dateArr?.sort((a, b) => {
            return moment(a).valueOf() - moment(b).valueOf()
          })
        } else {
          this.teachAddArrWis[index].dateArr?.splice(fIndex, 1)
        }
      } else if (this.roomType == ROOM_TYPE_ENUM.SMALLEST) {
        // 没有日期就添加 有就删除
        let fIndex = this.teachAddArrSma[index].dateArr?.findIndex(
          (item) => moment(item).valueOf() == moment(value).valueOf()
        )
        if (fIndex == -1) {
          this.teachAddArrSma[index].dateArr?.push(value)
          this.teachAddArrSma[index].dateArr?.sort((a, b) => {
            return moment(a).valueOf() - moment(b).valueOf()
          })
        } else {
          this.teachAddArrSma[index].dateArr?.splice(fIndex, 1)
        }
      }
    },
    moment,
    async init() {
      // 初始化各项的值
      try {
        let schoolRes = await this.$http.getSelectSchoolList()
        if (schoolRes.code !== 200) {
          throw '初始化学校失败!请稍候重试'
        } else {
          this.schoolListSim = schoolRes.rt
          this.schoolListWis = schoolRes.rt
        }
        let termRes = await this.$http.getTermInfo()
        if (termRes.code !== 200) {
          throw '获取学期失败!'
        } else {
          this.termInfo = Object.keys(termRes.rt).map((item) => {
            return {
              value: item,
              name: termRes.rt[item],
            }
          }).reverse()
        }
      } catch (error) {
        // this.$message.error(error || '初始化数据失败')
      }
      try {
        let commissionerRes = await this.$http.findAllCommissionerList()
        if (commissionerRes.code == 200 && commissionerRes.rt) {
          this.commissionerList = (commissionerRes.rt || []).map(item => {
            return {
              ...item,
              name: item.realName,
            }
          }) || []
        }
      } catch (error) {}
    },
    // modal关闭
    afterClose() {
      this.listenDataWis = []
      this.listenDataSma = []
      this.roomType = ROOM_TYPE_ENUM.SIMPLE
      this.teachAddArrSim = [
        {
          index: 0,
          dateArr: [],
          showDate: false,
        },
      ]
      this.teachAddArrWis = [
        {
          index: 0,
          dateArr: [],
          showDate: false,
        },
      ]
      this.teachAddArrSma = [
        {
          index: 0,
          dateArr: [],
          showDate: false,
        },
      ]
      this.submitLoading = false
      this.$emit('update:showModalProp', false)
    },
    confirmDelete() {
      if (this.deleteData.key || this.deleteData.key == 0) {
        if (this.roomType == ROOM_TYPE_ENUM.WISDOM) {
          const indexSpecial = (this.listenDataWis || []).findIndex(v => v.key === this.deleteData.key)
          this.listenDataWis.splice(indexSpecial, 1)
        } else if (this.roomType == ROOM_TYPE_ENUM.SMALLEST) {
          const indexSpecial = (this.listenDataSma || []).findIndex(v => v.key === this.deleteData.key)
          this.listenDataSma.splice(indexSpecial, 1)
        }
      }
    },
    deleteListenOneData(data) {
      this.deleteModalShow = true
      this.deleteData = data
    },
    /**
     * @description: 添加收视教室
     * @param {*}
     * @return {*}
     */
    handleAddListenClassRoomClick() {
      if (this.roomType == ROOM_TYPE_ENUM.WISDOM) {
        let data = this.wisdomForm.getFieldsValue()
        let school =
          this.schoolListWis.find((item) => item.id == data.listenSchool) || {}
        let classRoom =
          this.listenClassRoomList.find(
            (item) => item.classroomCode == data.listenClassroom
          ) || {}
        let teacher =
          this.teacherListListenWis.find(
            (item) => item.zhsId == data.listenDaobo
          ) || {}
        this.listenDataWis.push({
          id: school.id,
          key: this.listenDataWis.length,
          schoolName: school.schoolName || '',
          schoolId: school.schoolId || '',
          className: classRoom.classroomName || '',
          classId: classRoom.classroomCode || '',
          roomType: '听课',
          realName: teacher.realName || '',
          mobile: teacher.mobile || '',
          zhsId: teacher.zhsId || '',
          classroomTypeName: classRoom.classroomTypeName
        })
      } else if (this.roomType == ROOM_TYPE_ENUM.SMALLEST) {
        let data = this.smallestForm.getFieldsValue()
        let school =
          this.schoolListWis.find((item) => item.id == data.listenSchool) || {}
        let classRoom =
          this.listenClassRoomList.find(
            (item) => item.classroomCode == data.listenClassroom
          ) || {}
        let teacher =
          this.teacherListListenSma.find(
            (item) => item.zhsId == data.listenDaobo
          ) || {}
        this.listenDataSma.push({
          id: school.id,
          key: this.listenDataSma.length,
          schoolName: school.schoolName || '',
          schoolId: school.schoolId || '',
          className: classRoom.classroomName || '',
          classId: classRoom.classroomCode || '',
          roomType: '听课',
          realName: teacher.realName || '',
          mobile: teacher.mobile || '',
          zhsId: teacher.zhsId || '',
          classroomTypeName: classRoom.classroomTypeName
        })
      }
    },
    async handleListenSchoolChange(value) {
      let schoolData = this.schoolListWis.find((item) => item.id == value) || {}
      let classRoomRes = await this.$http.getListenClassRoomListForAll({
        schoolId: schoolData.schoolId,
      })
      if (classRoomRes.code !== 200) {
        this.$message.error(classRoomRes.msg)
        return
      }
      this.listenClassRoomList = classRoomRes.rt
    },
    async handleListenClassRoomChange(value) {
      if (this.roomType == ROOM_TYPE_ENUM.WISDOM) {
        let teacherRes = await this.$http.getSelectTeacherList({
          classCodes: value,
        })
        if (teacherRes.code !== 200) return this.$message.error(teacherRes.msg)
        this.teacherListListenWis = teacherRes.rt[value]
      } else if (this.roomType == ROOM_TYPE_ENUM.SMALLEST) {
        let teacherRes = await this.$http.getSelectTeacherList({
          classCodes: value,
        })
        if (teacherRes.code !== 200) return this.$message.error(teacherRes.msg)
        this.teacherListListenSma = teacherRes.rt[value]
      }
    },
    async handleSchoolChange(value) {
      if (this.roomType === ROOM_TYPE_ENUM.SIMPLE) {
        let schoolData =
          this.schoolListSim.find((item) => item.id == value) || {}
        let classRoomRes = await this.$http.liveListClassRoomBySchoolId({
          schoolId: schoolData.schoolId,
        })
        if (classRoomRes.code !== 200) {
          this.$message.error(classRoomRes.msg)
          return
        }
        this.classRoomListSim = classRoomRes.rt.list
        this.handleClassRoomChange(value)
      } else if (this.roomType == ROOM_TYPE_ENUM.WISDOM) {
        let schoolData =
          this.schoolListWis.find((item) => item.id == value) || {}
        let classRoomRes = await this.$http.getSelectClassRoomList({
          schoolCode: schoolData.schoolId,
        })
        if (classRoomRes.code !== 200) {
          this.$message.error(classRoomRes.msg)
          return
        }
        this.classRoomListWis = classRoomRes.rt
      } else if (this.roomType == ROOM_TYPE_ENUM.SMALLEST) {
        let schoolData =
          this.schoolListWis.find((item) => item.id == value) || {}
        let classRoomRes = await this.$http.getSmallestClassRoomList({
          schoolId: schoolData.schoolId,
        })
        if (classRoomRes.code !== 200) {
          this.$message.error(classRoomRes.msg)
          return
        }
        this.classRoomListSma = classRoomRes.rt || []
        // this.smallestForm.resetFields(['classRoomId', 'teacherId'])
      }
    },
    async handleClassRoomChange(value) {
      if (this.roomType === ROOM_TYPE_ENUM.SIMPLE) {
        let schoolData =
          this.schoolListSim.find(
            (item) => item.id == this.simpleForm.getFieldValue('schoolId')
          ) || {}
        let teacherRes = await this.$http.liveListTeacherBySchoolId({
          schoolId: this.editModel?.show ? value : schoolData.schoolId,
        })
        if (teacherRes.code !== 200) {
          this.$message.error(teacherRes.msg)
          return
        }
        this.teacherListSim = teacherRes.rt?.list?.map((item) => {
          return {
            zhsId: item.id,
            realName: item.name,
          }
        })
      } else if (this.roomType == ROOM_TYPE_ENUM.WISDOM) {
        let teacherRes = await this.$http.getSelectTeacherList({
          classCodes: value,
        })
        if (teacherRes.code !== 200) {
          this.$message.error(teacherRes.msg)
          return
        }
        this.teacherListWis = teacherRes.rt[value]
      } else if (this.roomType == ROOM_TYPE_ENUM.SMALLEST) {
        let teacherRes = await this.$http.getAllRoomDaoboDetail()
        if (teacherRes.code !== 200) {
          this.$message.error(teacherRes.msg)
          return
        }
        this.teacherListSma = teacherRes.rt || []
      }
    },
    formatSubmitDate(day, startTime, endTime) {
      let startTimeValue = ''
      let endTimeValue = ''
      if (day) {
        day?.hours(0)
        day?.minutes(0)
        day?.seconds(0)
      }
      if (startTime) {
        startTimeValue =
          (startTime?.hour() * 60 + startTime?.minute()) * 60 * 1000
      }
      if (endTime) {
        endTimeValue = (endTime?.hour() * 60 + endTime?.minute()) * 60 * 1000
      }
      return {
        startTime: day?.valueOf() + startTimeValue,
        endTime: day?.valueOf() + endTimeValue,
      }
    },
    async saveClassRoom() {
      this.handScrollChange()
      if (this.roomType === ROOM_TYPE_ENUM.SIMPLE) {
        this.teachAddArrSim.forEach((arrItem, arrIndex) => {
          if (arrItem.dateArr.length == 0) {
            this.simpleForm.setFieldsValue({
              [`courseTime${arrIndex}`]: undefined,
            })
          }
        })
        // 极简教室表单校验和处理提交数据
        this.simpleForm.validateFieldsAndScroll(async (error) => {
          if (!error) {
            let data = this.simpleForm.getFieldsValue()
            let timeList = []
            this.teachAddArrSim.map((item, index) => {
              let day = item.dateArr || []
              let startTime = data[`startTime${index}`]
              let endTime = data[`endTime${index}`]
              day.forEach((item1) => {
                timeList.push(this.formatSubmitDate(item1, startTime, endTime))
              })
            })
            let classRoomData =
              this.classRoomListSim?.find(
                (item) => item.classroomCode == data.classRoomId
              ) || {}
            let teacherData =
              this.teacherListSim?.find(
                (item) => item.zhsId == data.teacherId
              ) || {}
            let schoolData = this.schoolListSim.find(
              (item) => item.id == data.schoolId
            )
            let submitData = {
              schoolCode: schoolData.schoolId || '',
              schoolId: schoolData.id || '',
              classRoomId: data.classRoomId || '',
              className: classRoomData.classroomName || '',
              teacherId: data.teacherId || '',
              teacherName: teacherData.name || '',
              courseName: data.courseName || '',
              term: data.term || '',
              timeList,
            }
            for (let i = 0; i < timeList.length; i++) {
              let { startTime, endTime } = timeList[i]
              // 检查开始时间是否大于结束时间  是的话就给出错误提示并阻止提交
              if (startTime > endTime) {
                this.$message.error('开始时间不能晚于结束时间！')
                return
              }
            }
            this.submitLoading = true
            let result = await this.$http.createSimpleCourse(submitData)
            if (result.code !== 200) {
              this.submitLoading = false
              return this.$message.error(result.msg)
            }
            let { rt: resultReally } = result
            if (resultReally.resultStatus !== 1) {
              this.submitLoading = false
              return this.$message.error(
                resultReally.resultMessage
                  ? resultReally.resultMessage
                  : '创建失败'
              )
            }
            this.$message.success('创建课程成功')
            this.loadingTimer = setTimeout(() => {
              this.$emit('refresh')
              this.submitLoading = false
              this.showModal = false
            }, 1500)
            // 重置表单
            // this.simpleForm.resetFields()
          }
        })
      } else if (this.roomType == ROOM_TYPE_ENUM.WISDOM) {
        this.teachAddArrWis.forEach((arrItem, arrIndex) => {
          if (arrItem.dateArr.length == 0) {
            this.wisdomForm.setFieldsValue({
              [`courseTimeWis${arrIndex}`]: undefined,
            })
          }
        })
        // 智慧教室表单校验和处理提交数据
        this.wisdomForm.validateFieldsAndScroll(async (error) => {
          if (!error) {
            let data = this.wisdomForm.getFieldsValue()
            // 时间处理
            let timeList = []
            this.teachAddArrWis.map((item, index) => {
              let day = item.dateArr || []
              let startTime = data[`startTime${index}`]
              let endTime = data[`endTime${index}`]
              day.forEach((item1) => {
                timeList.push(this.formatSubmitDate(item1, startTime, endTime))
              })
            })
            // 主讲教室处理
            let zjSchoolData =
              this.schoolListWis.find((item) => item.id == data.schoolId) || {}
            let zjClassRoomData =
              this.classRoomListWis.find(
                (item) => item.classroomCode == data.classRoomId
              ) || {}
            let zjTeacherData =
              this.teacherListWis.find(
                (item) => item.zhsId == data.teacherId
              ) || {}
            let commissioner = this.commissionerList.find(item => item.id == data.commissionerId) || {}
            let teachClass = {
              schoolCode: zjSchoolData.schoolId || '',
              schoolId: zjSchoolData.id || '',
              schoolName: zjSchoolData.schoolName || '',
              classCode: zjClassRoomData.classroomCode || '',
              className: zjClassRoomData.classroomName || '',
              supporterName: zjTeacherData.realName || '',
              supporterPhone: zjTeacherData.mobile || '',
              supporterZhsId: zjTeacherData.zhsId || '',
              supporterEmail: zjTeacherData.email || '',
              tactics: data.tactics || '',
              classroomTypeName: zjClassRoomData.classroomTypeName
              // teachPhone: data.teachPhone || '',
            }

            // 收视教室处理
            let watchClassList = this.listenDataWis.map((item) => {
              return {
                schoolId: item.id,
                schoolCode: item.schoolId,
                schoolName: item.schoolName,
                classCode: item.classId,
                className: item.className,
                supporterName: item.realName,
                supporterPhone: item.mobile,
                supporterZhsId: item.zhsId,
                supporterEmail: item.email,
                classroomTypeName: item.classroomTypeName
              }
            })
            let submitData = {
              courseName: data.liveName || '',
              term: data.term || '',
              teacherName: data.teacherName || '',
              teachPhone: data.teachPhone || '',
              liveClassType: 1,
              teachClass,
              watchClassList,
              timeList,
              commissioner: commissioner.name || '',
              commissionerUserId: commissioner.zhsId || ''
            }
            for (let i = 0; i < timeList.length; i++) {
              let { startTime, endTime } = timeList[i]
              // 检查开始时间是否大于结束时间  是的话就给出错误提示并阻止提交
              if (startTime > endTime) {
                this.$message.error('开始时间不能晚于结束时间！')
                return
              }
            }
            this.submitLoading = true
            const realSubmit = async () => {
              let result = {}
              try {
                result = await this.$http.createLcCourse(submitData)
              } catch (error) {
                this.submitLoading = false
                this.$message.error('服务器开小差了')
              }
              if (result.code !== 200) {
                this.submitLoading = false
                return this.$message.error(result.msg)
              }
              if (
                result.rt.errorInfo !== '' &&
                typeof result.rt.errorInfo == 'string'
              ) {
                this.submitLoading = false
                return this.$message.error(
                  result.rt.errorInfo ? result.rt.errorInfo : '创建失败'
                )
              }
              // this.$message.success('创建课程成功')
              // this.loadingTimer = setTimeout(() => {
              //   this.$emit('refresh')
              //   this.submitLoading = false
              //   this.showModal = false
              // }, 1500)
              this.loadingCourseId = result.rt.courseId
              this.showLoadingCreateDialog = true
            }
            // 检查时间
            let timeCheckRes = await this.$http.checkLcClassInfo(submitData)
            if (timeCheckRes.rt.checkInfo != '' || timeCheckRes.code != 200) {
              // return this.$message.error(timeCheckRes.rt.resultMessage)
              if (
                !timeCheckRes.rt.timeList.length &&
                timeCheckRes.rt.checkInfo
              ) {
                this.submitLoading = false
                return this.$message.error(timeCheckRes.rt.checkInfo)
              }
              this.$confirm({
                title: '以下排课时间冲突，是否继续排定未冲突的课次？',
                // content: timeCheckRes.rt.checkInfo,
                content: (h) => {
                  let info = timeCheckRes.rt.checkInfo
                  let infoArr = info.split('\n')
                  return infoArr.map((item) => {
                    return <div>{item}</div>
                  })
                },
                zIndex: 9999,
                centered: true,
                okText: '确定',
                width: 850,
                okType: 'primary',
                cancelText: '取消',
                mask: true,
                maskClosable: true,
                icon: 'exclamation-circle',
                onOk: () => {
                  submitData.timeList = timeCheckRes.rt.timeList
                  realSubmit()
                },
                onCancel: () => {
                  this.submitLoading = false
                },
              })
            } else {
              realSubmit()
            }
          }
        })
      } else if (this.roomType == ROOM_TYPE_ENUM.SMALLEST) {
        // 极简教室当主讲 表单提交
        this.teachAddArrSma.forEach((arrItem, arrIndex) => {
          if (arrItem.dateArr.length == 0) {
            this.smallestForm.setFieldsValue({
              [`courseTimeWis${arrIndex}`]: undefined,
            })
          }
        })

        this.smallestForm.validateFieldsAndScroll(async (error) => {
          if (!error) {
            let data = this.smallestForm.getFieldsValue()
            // 时间处理
            let timeList = []
            this.teachAddArrSma.map((item, index) => {
              let day = item.dateArr || []
              let startTime = data[`startTime${index}`]
              let endTime = data[`endTime${index}`]
              day.forEach((item1) => {
                timeList.push(this.formatSubmitDate(item1, startTime, endTime))
              })
            })
            // 主讲教室处理
            let zjSchoolData =
              this.schoolListWis.find((item) => item.id == data.schoolId) || {}
            let zjClassRoomData =
              this.classRoomListSma.find(
                (item) => item.classroomCode == data.classRoomId
              ) || {}
            let zjTeacherData =
              this.teacherListSma.find(
                (item) => item.zhsId == data.teacherId
              ) || {}
            let commissioner = this.commissionerList.find(item => item.id == data.commissionerId) || {}
            let teachClass = {
              schoolCode: zjSchoolData.schoolId || '',
              schoolId: zjSchoolData.id || '',
              schoolName: zjSchoolData.schoolName || '',
              classCode: zjClassRoomData.classroomCode || '',
              className: zjClassRoomData.classroomName || '',
              supporterName: zjTeacherData.realName || '',
              supporterPhone: zjTeacherData.mobile || '',
              supporterZhsId: zjTeacherData.zhsId || '',
              supporterEmail: zjTeacherData.email || '',
              tactics: data.tactics || '',
              classroomTypeName: zjClassRoomData.classroomTypeName
              // teachPhone: data.teachPhone || '',
            }

            // 收视教室处理
            let watchClassList = this.listenDataSma.map((item) => {
              return {
                schoolId: item.id,
                schoolCode: item.schoolId,
                schoolName: item.schoolName,
                classCode: item.classId,
                className: item.className,
                supporterName: item.realName,
                supporterPhone: item.mobile,
                supporterZhsId: item.zhsId,
                supporterEmail: item.email,
                classroomTypeName: item.classroomTypeName
              }
            })
            let submitData = {
              courseName: data.liveName || '',
              term: data.term || '',
              teacherName: data.teacherName || '',
              teachPhone: data.teachPhone || '',
              liveClassType: 0,
              teachClass,
              watchClassList,
              timeList,
              commissioner: commissioner.name || '',
              commissionerUserId: commissioner.zhsId || ''
            }
            for (let i = 0; i < timeList.length; i++) {
              let { startTime, endTime } = timeList[i]
              // 检查开始时间是否大于结束时间  是的话就给出错误提示并阻止提交
              if (startTime > endTime) {
                this.$message.error('开始时间不能晚于结束时间！')
                return
              }
            }
            this.submitLoading = true
            const realSubmit = async () => {
              let result = {}
              try {
                result = await this.$http.createLcCourse(submitData)
              } catch (error) {
                this.submitLoading = false
                this.$message.error('服务器开小差了')
              }
              if (result.code !== 200) {
                this.submitLoading = false
                return this.$message.error(result.msg)
              }
              if (
                result.rt.errorInfo !== '' &&
                typeof result.rt.errorInfo == 'string'
              ) {
                this.submitLoading = false
                return this.$message.error(
                  result.rt.errorInfo ? result.rt.errorInfo : '创建失败'
                )
              }
              this.loadingCourseId = result.rt.courseId
              this.showLoadingCreateDialog = true
            }
            // 检查时间
            let timeCheckRes = await this.$http.checkLcClassInfo(submitData)
            if (timeCheckRes.rt.checkInfo != '' || timeCheckRes.code != 200) {
              // return this.$message.error(timeCheckRes.rt.resultMessage)
              if (
                !timeCheckRes.rt.timeList.length &&
                timeCheckRes.rt.checkInfo
              ) {
                this.submitLoading = false
                return this.$message.error(timeCheckRes.rt.checkInfo)
              }
              this.$confirm({
                title: '以下排课时间冲突，是否继续排定未冲突的课次？',
                // content: timeCheckRes.rt.checkInfo,
                content: (h) => {
                  let info = timeCheckRes.rt.checkInfo
                  let infoArr = info.split('\n')
                  return infoArr.map((item) => {
                    return <div>{item}</div>
                  })
                },
                zIndex: 9999,
                centered: true,
                okText: '确定',
                width: 850,
                okType: 'primary',
                cancelText: '取消',
                mask: true,
                maskClosable: true,
                icon: 'exclamation-circle',
                onOk: () => {
                  submitData.timeList = timeCheckRes.rt.timeList
                  realSubmit()
                },
                onCancel: () => {
                  this.submitLoading = false
                },
              })
            } else {
              realSubmit()
            }
          }
        })
      }
    },
  },
}
</script>

<style lang="scss" scoped>
::v-deep .course_time_picker {
  top: -4px !important;
}
::v-deep .ant-calendar-input-wrap {
  display: none;
}
::v-deep .ant-calendar {
  margin-top: 36px;
}

::v-deep .ant-modal-close {
  z-index: 2 !important;
}

::v-deep .classmodal_content {
  .ant-form-item-label {
    line-height: 26px;
  }
  .course_date_active {
    box-shadow: 0 0 2px #40a9ff;
    border-color: #1890ff !important;
    border-width: 1px;
  }
  .has-error {
    .course_date {
      box-shadow: 0 0 2px #f5222d;
      border-color: #f5222d !important;
      border-width: 1px;
    }
  }
  .course_date {
    position: relative;
    border: 1px solid #d9d9d9;
    border-radius: 4px;
    height: 32px;
    cursor: pointer;
    width: 285px;
    display: flex;
    align-items: center;
    &:focus {
      border-color: #40a9ff;
      border-right-width: 1px;
    }

    .tag_list {
      display: flex;
      align-items: center;
      overflow: hidden;
      width: 250px;
      .placeholder {
        margin-left: 10px;
        color: #bfbfbf;
      }
      .course_date_tag {
        font-size: 14px;
        background-color: #1890ff;
        color: #fff;
        border-radius: 4px;
        margin-left: 3px;
        padding: 0 3px;
        width: 80px;
        flex-shrink: 0;
        cursor: pointer;
      }
    }
    .ellipsis {
    }
    > i {
      position: absolute;
      right: 5px;
      cursor: pointer;
    }
  }
  .content_btntab {
    display: flex;
    margin-bottom: 15px;
    button:first-child {
      margin-right: 30px;
    }
    button:nth-child(2) {
      margin-right: 30px;
    }
    button {
      width: 150px;
      &:hover {
        border: 1px solid #d9d9d9 !important;
      }
    }
    .ant-btn-default {
      background-color: #efefef;
      color: #7f7f7f;
    }
    .ant-btn {
      &:active {
        border: none;
      }
      &:hover {
        border: none;
      }
      &:focus {
        border: none;
      }
    }
  }
  h3 {
    font-weight: bold;
    margin-top: 20px;
    margin-bottom: 0;
  }
  .ant-form-item {
    margin-bottom: 0;
  }
  .simple_box {
    h3 {
      margin-top: 20px;
      margin-bottom: 0;
    }
  }
  .shouke_btn_add,
  .shouke_btn_del {
    position: absolute;
    right: -60px;
    top: 30px;
    font-size: 18px;
  }
  .scroll-box {
    overflow-y: scroll;
    max-height: 550px;
    .content_table {
      margin-top: 15px;
    }
    .add_class_room_btn {
      position: absolute;
      right: -145px;
      top: -9px;
    }
  }
}
</style>
